import MuiListItem, {
  type ListItemProps as MuiListItemProps,
} from '@mui/material/ListItem';

export type ListItemProps = MuiListItemProps;

export default function ListItem(props: ListItemProps) {
  return <MuiListItem {...props} />;
}
